<dv-tabs [tabLinks]="tabLinks" />
<div class="tabs-content">
  <router-outlet />
</div>
